"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = _interopRequireDefault(require("immutable"));

var _formatters = require("../utils/formatters");

var EMPTY_SET = _immutable.default.Set();

var defaults = {
  installed: null,
  hubInstallable: null,
  hubUserInstallable: null,
  incompatibleHubInstalls: EMPTY_SET,
  incompatibleHubUserInstalls: EMPTY_SET,
  missingHubScopeGroups: EMPTY_SET,
  missingHubScopes: EMPTY_SET,
  missingHubUserRoles: EMPTY_SET,
  missingHubUserScopes: EMPTY_SET,
  missingNonTrialHubScopeGroups: EMPTY_SET,
  missingNonTrialHubScopes: EMPTY_SET,
  missingNonTrialHubUserRoles: EMPTY_SET,
  missingNonTrialHubUserScopes: EMPTY_SET,
  nonTrialHubInstallable: null,
  nonTrialHubUserInstallable: null
};

var AppInstallability = /*#__PURE__*/function (_Immutable$Record) {
  (0, _inherits2.default)(AppInstallability, _Immutable$Record);

  function AppInstallability() {
    var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2.default)(this, AppInstallability);
    Object.keys(json).forEach(function (key) {
      var value = json[key];
      var defaultValue = defaults[key];

      if (_immutable.default.Set.isSet(defaultValue)) {
        json[key] = _immutable.default.Set(value);
      }
    });
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AppInstallability).call(this, (0, _formatters.cleanObject)(json)));
  }

  return AppInstallability;
}(_immutable.default.Record(defaults));

var _default = AppInstallability;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/records/AppInstallability.js
// module id = 244
// module chunks = 209 210 211 212